import SmartLook from 'smartlook-client'

const eventMapping = {
  addPaymentInfo: { ga4: 'add_payment_info', fbq: 'AddPaymentInfo' },
  completeRegistration: { ga4: 'sign_up', fbq: 'CompleteRegistration' },
  login: { ga4: 'login', fbq: 'Login' },
  contact: { ga4: 'contact', fbq: 'Contact' },
  initiateCheckout: { ga4: 'begin_checkout', fbq: 'InitiateCheckout' },
  purchase: { ga4: 'purchase', fbq: 'Purchase' },
  search: { ga4: 'search', fbq: 'Search' },
  viewContent: { ga4: 'view_item', fbq: 'ViewContent' },
  submitApplication: { ga4: 'submit_application', fbq: 'SubmitApplication' },
  applyFilter: { ga4: 'apply_filter', fbq: 'FilterApplied' },
  tutorRegistrationBegin: { ga4: 'sign_up_tutor_begin', fbq: 'TutorRegistrationBegin' },
  tutorRegistrationEnd: { ga4: 'sign_up_tutor_end', fbq: 'TutorRegistrationEnd' },
}

export function initialiseAnalytics() {
  SmartLook.init('aa88809c5f74abb36353619521f64e97c3865ec3', { region: 'eu' })
}

export function trackEvent(event, params = {}) {
  const mappedEvent = eventMapping[event]

  if (!mappedEvent) {
    console.warn(
      `[Analytics] Event '${event}' is not mapped to GA4 or Facebook Pixel.`
    )
    return
  }

  // console.log(`[Analytics] trackEvent: ${event}`, {
  //     ga4: mappedEvent.ga4,
  //     fbq: mappedEvent.fbq,
  //     params,
  //     gtag_available: typeof window.gtag === 'function',
  //     fbq_available: typeof window.fbq === 'function',
  // });

  if (typeof window.gtag === 'function') {
    window.gtag('event', mappedEvent.ga4, params)
  }

  // Push to Google Tag Manager dataLayer
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: mappedEvent.ga4,
      ...params,
    })
  }

  if (typeof window.fbq === 'function') {
    window.fbq('track', mappedEvent.fbq, params)
  }
}
